<template>
  <aside v-if="notice" class="mega-notice" role="alert" aria-atomic="true"
    @mouseenter="pause" @mouseleave="startTimer" @focusin="pause" @focusout="startTimer">
    <strong>{{ notice.title }}</strong>
    <p>{{ $t(notice.message) }}</p>
    <button type="button" aria-label="알림 닫기" @click="dismiss"><img src="@/assets/img/icon_x.svg" alt="" /></button>
  </aside>
</template>

<script>
export default {
  name: 'MegaNotice',
  data () {
    return { notice: null, timer: null }
  },
  mounted () {
    this.emitter.on('MegaNotice', this.show)
  },
  beforeUnmount () {
    this.emitter.off('MegaNotice', this.show)
    this.pause()
  },
  methods: {
    show (notice) {
      this.notice = notice
      this.pause()
      if (notice) this.startTimer()
    },
    pause () {
      clearTimeout(this.timer)
    },
    startTimer () {
      this.pause()
      this.timer = setTimeout(this.dismiss, 10000)
    },
    dismiss () {
      this.pause()
      this.notice = null
    }
  }
}
</script>

<style scoped>
.mega-notice { position: fixed; z-index: 10000; top: 8px; left: 50%; transform: translateX(-50%); box-sizing: border-box; width: min(360px, calc(100% - 8px)); padding: 18px 30px; border-radius: 4px; background: rgba(28, 30, 32, .94); text-align: center; font-family: 'Mega SUIT', Arial, sans-serif; box-shadow: 0 5px 18px #0003; }
.mega-notice strong { display: block; color: #f7f3e6; font-size: 15px; line-height: 1.4; }
.mega-notice p { margin: 3px 0 0; color: #f18b80; font-size: 12px; line-height: 1.5; overflow-wrap: anywhere; }
.mega-notice button { position: absolute; top: 0; right: 0; width: 30px; height: 30px; border: 0; padding: 8px; background: transparent; cursor: pointer; }
.mega-notice img { display: block; width: 14px; height: 14px; filter: brightness(1.8); }
.mega-notice button:focus-visible { outline: 2px solid #bffff0; outline-offset: -3px; }
</style>
